import { FC } from "react";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useNotify, useRefresh } from "react-admin";

import ConfirmationPopover from "../../../../components/ConfirmationPopover";
import { DocReference } from "../../../../types/firebase.types";

const DeleteReview: FC<any> = (props) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const handleDelete = async (ref: DocReference) => {
    try {
      await ref.delete();
      refresh();
      notify("Review deleted", "success");
    } catch (ex: any) {
      console.log(ex.message);
      notify("Error on deleting review", "error");
    }
  };

  return (
    <ConfirmationPopover
      onConfirm={() => handleDelete(props.record.ref)}
      message="Are you sure you want to delete review?"
      confirmationText="Confirm"
      confirmationColor="secondary"
      Icon={
        <IconButton>
          <DeleteIcon color="error" />
        </IconButton>
      }
    />
  );
};

export default DeleteReview;
